// extracted by css-extract-rspack-plugin
var _1 = "cuVOL6b7fpAjnAhN";
var _2 = "cuVOL6b7fpAjnAhN";
var _3 = "YdSl8GaECBYHkLL0";
export { _1 as "editorialInfo", _2 as "editorial_info", _3 as "huge" }
